import { render, staticRenderFns } from "./Sustainability.vue?vue&type=template&id=016108b6&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Sustainability.vue?vue&type=script&lang=js&"
export * from "./Sustainability.vue?vue&type=script&lang=js&"
import style0 from "./Sustainability.vue?vue&type=style&index=0&id=016108b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016108b6",
  null
  
)

export default component.exports